<template>
  <div class="pages" :class="{ Mobiles: $store.state.isMobile !== 2 }">
    <Mobileheader name="产品与方案" routeNmae="/solutioNav"  v-if="$store.state.isMobile !== 3"/>
    <!-- <iframe :src="pdfUrl" class="pdfBox"></iframe> -->
    <!-- <img v-if="type==1" class="bannerImg" src="@/assets/img/cqjjfa.jpg" alt="">
    <img v-if="type==2" class="bannerImg" src="@/assets/img/kfqjcsc.jpg" alt=""> -->
    <pdf ref="pdf" v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf>
    <div class="more" v-if="httpUrl">
      <img class="gifmore" src="@/assets/img/lookMore.gif" alt="" @click="onHttpUrl">
    </div>
    <div>
      <CopyRight v-if="!$route.query.isApplet"></CopyRight>
    </div>
  </div>
</template>

<script>
// isApplet 1是小程序跳转的
import vuePdf from "vue-pdf";
const pdf = { ...vuePdf, destroyed: undefined }

export default {
  components: {
    pdf
  },


  data() {
    return {
      pdfUrl: "",
      numPages: undefined,
      httpUrl: "",
      type: 1
    }
  },

  mounted() {
    this.numPages = undefined;
    this.type = this.$route.query.type
    this.openPage()

  },
  methods: {
    openPage() {
      let name = this.$route.query.name;

      this.httpUrl = this.$route.query.url
      let url = this.$route.query.name;
      url = url.replace('https://www.dpark.com.cn', 'https://www.dpark.com.cn')
      var loadingTask = pdf.createLoadingTask(url);

      this.pdfUrl = loadingTask;

      console.log('name:', url)
      this.pdfUrl.promise.then(pdf => {
        this.numPages = pdf.numPages;
        console.log(this.numPages, pdf.numPages)
      }).catch(err => {
        console.log('err', err)
      });

    },
    onHttpUrl() {
      window.open(this.httpUrl, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.pages {
  position: relative;

  .bannerImg {
    width: 100%;
    display: block;
  }

  .more {
    position: absolute;
    top: 10px;
    right: 10px;

    .gifmore {
      width: 100px;
    }
  }
}
</style>